<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, email } from '@vuelidate/validators';
import router from '../../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';
import NextInput from 'dashboard/components-next/input/Input.vue';

export default {
  components: {
    NextButton,
    NextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      email: '',
      alertMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    email: { required, email },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const emailChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName?.trim(),
            channel: {
              type: 'email',
              email: this.email,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: emailChannel.id,
          },
        });
      } catch (error) {
        const errorMessage = error?.message;
        this.alertMessage =
          errorMessage ||
          this.$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.API.ERROR_MESSAGE');
        useAlert(this.alertMessage);
      }
    },
  },
};
</script>

<template>
  <section
    class="w-full max-w-3xl px-4 py-6 mx-auto sm:px-6 sm:py-8"
    aria-labelledby="email-channel-title"
  >
    <div class="max-w-2xl">
      <p class="mb-2 text-xs font-semibold text-n-violet-11">
        {{ $t('INBOX_MGMT.CREATE_FLOW.BUILDER.STEP_LABEL', { step: 2 }) }}
      </p>
      <h2
        id="email-channel-title"
        class="text-2xl font-semibold tracking-tight text-n-slate-12"
      >
        {{ $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.TITLE') }}
      </h2>
      <p class="mt-2 mb-0 text-sm leading-6 text-n-slate-11">
        {{ $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.DESC') }}
      </p>
    </div>

    <form class="flex flex-col gap-5 mt-7" @submit.prevent="createChannel()">
      <fieldset
        class="min-w-0 p-5 border rounded-xl border-n-weak bg-n-solid-1"
      >
        <div class="flex flex-col gap-4">
          <NextInput
            v-model="channelName"
            :label="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CHANNEL_NAME.LABEL')"
            :placeholder="
              $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            :message="
              v$.channelName.$error
                ? $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CHANNEL_NAME.ERROR')
                : ''
            "
            :message-type="v$.channelName.$error ? 'error' : 'info'"
            @blur="v$.channelName.$touch"
          />
          <NextInput
            v-model="email"
            :label="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.EMAIL.LABEL')"
            :placeholder="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.EMAIL.PLACEHOLDER')"
            :message="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.EMAIL.SUBTITLE')"
            :message-type="v$.email.$error ? 'error' : 'info'"
            @blur="v$.email.$touch"
          />
        </div>
      </fieldset>

      <div class="flex justify-end">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </section>
</template>
